import dynamic from 'next/dynamic';

import type { DefaultTrialProps } from '../../trial-layout-switcher';

// Every LP of the registry is imported statically into /trial, so whatever this module pulls in ships to
// every visitor of every campaign. The page itself (its ~290 KB stylesheet, the Multiconexão and Multi
// Internet engines, the geo tables) is therefore a separate chunk, fetched only when this LP renders.
// Server-side rendering is kept: the chunk is rendered on the server and its CSS is in the first paint.
const V4cLanding = dynamic(() => import('./landing').then((module) => module.V4cLanding));

interface StarWarsProps extends DefaultTrialProps {}

export function StarWars({ daysTrial, trialConfigId, trialPageId, isDisabledButton = false }: StarWarsProps) {
  return <V4cLanding daysTrial={daysTrial} trialConfigId={trialConfigId} trialPageId={trialPageId} isDisabledButton={isDisabledButton} />;
}
